import React, { useContext, useEffect, useState } from "react";
import lodash, { get } from "lodash";
import utilCommon, { isReactAppAuthorized } from "../helpers/util-common";
import { Link, useNavigate } from "react-router-dom";
import { validateUrlParams } from "../helpers/util-common";
import { MODULES } from "../models/navigation.models";
import { setGlobalSearchText, SetWorkItemListData } from "../common.actions";
import { useDispatch } from "react-redux";
import { FeatureFlag } from "../provider/flagFeature";

interface Props {
  history: any;
}
const NavigationMenu = (props: Props) => {
  const { history } = props;
  const isUserAuthorized = isReactAppAuthorized();
  const featureData = useContext(FeatureFlag);
  const [navigationMenu, setNavigationMenu] = useState([]);
  const navigate = useNavigate()
  const dispatch = useDispatch()
  
  useEffect(() => {
    if (isUserAuthorized) {
      utilCommon.validateNavigationPermission().then((result: any) => {        
        setNavigationMenu(result);
      });
    }
  }, []);
  // Check Parent Url has exist hash
  const validateRouteUrl = (url: any) => {
    if (url && url.indexOf("#") > -1) {
      return url;
    }
    return `/${url}`;
  };
  // Render Parent Menu
  const renderParentMenu = (item: any, navIndex: any) => {
    return (
      item.isVisibleOnNavigation && (
        <li key={`${navIndex}_${lodash(item).get("ModuleName")}`}>
          <a 
            className={item.hasNavChild || item.routeUrl !== "#" ? "external-class" : "internal-class"} 
            data-testid="navigationParent-id"
            href={lodash(item).get("isExternalUrl") ? lodash(item).get("routeUrl") : validateRouteUrl(lodash(item).get("routeUrl"))}
                     >
              {lodash(item).get("ModuleName")}
            </a>

          {item.hasNavChild && item[MODULES[navIndex]] && item[MODULES[navIndex]].length > 0 && (
            <ul className={`subMenu ${lodash(item).get("ModuleName") == "ANSI" ? "ansi-submenu" : ""}`} key={item.uniqueKey}>
              {renderChildMenu(item[MODULES[navIndex]])} {lodash(item).get("isExternalUrl")}
            </ul>
          )}
        </li>
      )
    );
  };
  // Render Child Menu
  const renderChildMenu = (subItems: any) => {
    return (
      subItems &&
      subItems.length > 0 &&
      subItems.map((items: any, index: number) => {
        return (
          items.isVisibleOnNavigation && (
            <li key={`${index}_${lodash(items).get("title")}`}>
              <a className={items.hasNavChild || items.routeUrl !== "#" ? "external-class" : "internal-class"} href={lodash(items).get("isExternalUrl") ? lodash(items).get("routeUrl") : validateRouteUrl(lodash(items).get("routeUrl"))} data-testid="navigationChild-id">
                {lodash(items).get("title")}
              </a>
              {/* <Link to={lodash(items).get('isExternalUrl')==false ? { pathname: lodash(items).get('routeUrl') } : validateRouteUrl(lodash(items).get('routeUrl'))}>{lodash(items).get('title')}</Link> */}
            </li>
          )
        );
      })
    );
  };

  
  return (
    <div className="topMenuBar">
      <div className="container-fluid">
        <div className="menuWrapper dms-Menu">
          <ul>
            {navigationMenu &&
              navigationMenu.length > 0 &&
              navigationMenu.map((item: string, navIndex: number) => {
                return renderParentMenu(item, navIndex);
              })}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default NavigationMenu;
